import { useEffect } from 'react';

/**
 * NoIndex — drop-in component for private/internal pages.
 * Injects <meta name="robots" content="noindex, nofollow"> so Google,
 * Bing and other search engines skip the page in their index.
 *
 * Use on: admin, dashboards, profile, messages, chat, payment, booking flows.
 *
 *   <NoIndex />
 */
const NoIndex = () => {
  useEffect(() => {
    let el = document.querySelector('meta[name="robots"]');
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('name', 'robots');
      document.head.appendChild(el);
    }
    const previous = el.getAttribute('content');
    el.setAttribute('content', 'noindex, nofollow');
    return () => {
      // Restore previous robots directive when the user navigates away
      el.setAttribute('content', previous || 'index, follow');
    };
  }, []);
  return null;
};

export default NoIndex;
